/* 2TW FREE GIFTS ENGINE — replaces Koala.
   Reads #tw-gifts-config (rendered by snippets/tw-gifts.liquid inside the cart drawer),
   keeps gift lines (_tw_gift = t1 / t2 / t3) in sync with the paid subtotal, then refreshes the drawer. */
(function () {
  if (window.__twGifts) return;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var KEY_BEANIE = 'tw_gift_beanie', KEY_PICKS = 'tw_gift_picks';
  var busy = false, pending = false, bad = {}, runs = 0, runsReset = null, lastCart = null, bypass = null, selfRefresh = false, refT = null;

  function lsGet(k) { try { return JSON.parse(localStorage.getItem(k)); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function ssSet(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  function ssPop(k) { try { var v = sessionStorage.getItem(k); sessionStorage.removeItem(k); return v; } catch (e) { return null; } }

  function cfg() {
    var el = document.getElementById('tw-gifts-config');
    if (!el) return null;
    try {
      var c = JSON.parse(el.textContent);
      if (c && c.s) Object.keys(c.s).forEach(function (k) { var d = document.createElement('textarea'); d.innerHTML = c.s[k]; c.s[k] = d.value; }); // Liquid t-filter escapes ' & etc.
      return c && c.on ? c : null;
    } catch (e) { return null; }
  }
  function prop(i, k) { return i && i.properties ? i.properties[k] : null; }
  function isGift(i) { return !!prop(i, '_tw_gift'); }
  function isLegacy(i) { return !!prop(i, '__koala_gift'); }
  function norm(s) { return ' ' + String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim() + ' '; }
  function ok(id) { return id && !bad[id]; }

  function beanieWords(c) {
    // "off-white: white, cream" lines add extra match words to a colour
    var extra = {};
    String(c.aliases || '').split(/\n|\|/).forEach(function (line) {
      var p = line.split(':');
      if (p.length < 2) return;
      extra[norm(p[0])] = p[1].split(',').map(norm).filter(function (w) { return w.trim(); });
    });
    return c.beanies.map(function (b) {
      var base = norm(b.w);
      return { id: b.id, plain: !b.w || !b.w.trim(), words: base.trim() ? [base].concat(extra[base] || []) : [] };
    });
  }

  function chooseBeanie(c, cart) {
    var list = beanieWords(c).filter(function (b) { return ok(b.id); });
    if (!list.length) return null;
    var fallback = (list.filter(function (b) { return b.plain; })[0] || list[0]).id;
    var manual = lsGet(KEY_BEANIE);
    if (manual && list.some(function (b) { return b.id === manual; })) return manual;
    // the beanie follows the main piece in the bag: the most expensive sweatsuit / set / hoodie (else the most expensive item)
    var paid = cart.items.filter(function (i) { return !isGift(i) && !isLegacy(i); })
      .sort(function (a, b) { return b.final_line_price - a.final_line_price; });
    var main = paid.filter(function (i) { return /sweatsuit|tracksuit|hoodie|\bset\b/i.test(i.product_title); })[0] || paid[0];
    // bundles like "Chrome Sweatsuit + Free UNC Blue Sweatsuit": only the part before "+" / "free" names the colour
    var t = main ? norm(String(main.product_title).split(/\+|\bfree\b/i)[0] + ' ' + String(main.handle || '').split(/-free-/)[0]) : ' ';
    for (var j = 0; j < list.length; j++) {
      if (list[j].words.some(function (w) { return t.indexOf(w) > -1; })) return list[j].id;
    }
    return fallback; // black / reflective / anything without a colour beanie -> plain Essential Beanie
  }

  function choosePicks(c, cart) {
    var pool = (c.accs || []).filter(ok), n = Math.min(c.n || 2, pool.length), out = [];
    function push(id) { if (out.length < n && pool.indexOf(id) > -1 && out.indexOf(id) === -1) out.push(id); }
    (lsGet(KEY_PICKS) || []).forEach(push);
    cart.items.forEach(function (i) { if (prop(i, '_tw_gift') === 't2') push(i.variant_id); });
    pool.forEach(push); // first products in the list = preselected defaults
    return out;
  }

  // Pure planner: what the gift lines should be for this cart. Exported for testing.
  function plan(c, cart) {
    var giftSum = 0;
    cart.items.forEach(function (i) { if (isGift(i) || isLegacy(i)) giftSum += i.final_line_price; });
    var base = cart.items_subtotal_price - giftSum;
    var paidCount = cart.items.filter(function (i) { return !isGift(i) && !isLegacy(i); }).length;
    var want = [];
    if (paidCount > 0 && base >= c.t[0]) { var b = chooseBeanie(c, cart); if (b) want.push({ id: b, tier: 't1' }); }
    if (paidCount > 0 && base >= c.t[1]) choosePicks(c, cart).forEach(function (id) { want.push({ id: id, tier: 't2' }); });
    if (paidCount > 0 && base >= c.t[2] && ok(c.mystery)) want.push({ id: c.mystery, tier: 't3' });

    var updates = {}, have = {}, change = false;
    cart.items.forEach(function (i) {
      if (isLegacy(i)) { updates[i.key] = 0; change = true; return; }
      if (!isGift(i)) return;
      var tag = prop(i, '_tw_gift') + ':' + i.variant_id;
      var wanted = want.some(function (w) { return w.tier + ':' + w.id === tag; });
      if (!wanted || have[tag]) { updates[i.key] = 0; change = true; return; }
      have[tag] = true;
      if (i.quantity !== 1) { updates[i.key] = 1; change = true; }
    });
    var adds = want.filter(function (w) { return !have[w.tier + ':' + w.id]; });
    return { base: base, updates: change ? updates : null, adds: adds };
  }

  function post(url, body) {
    return fetch(ROOT + url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); });
  }
  function getCart() { return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }

  // re-render the drawer; flagged so our own refreshes don't re-trigger a sync
  function refreshDrawer() {
    selfRefresh = true;
    try { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } finally { selfRefresh = false; }
  }

  function setBusy(on) {
    var el = document.querySelector('[data-twg]');
    if (el) el.classList.toggle('is-busy', on);
  }

  function refreshUI(newTiers) {
    if (newTiers.length) ssSet('twg_new', newTiers.join(','));
    if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
    if (newTiers.length) watchForStrip();
    refreshDrawer();
  }

  // Wait for the re-rendered drawer, then play the unlock animation once
  function watchForStrip() {
    var mo = new MutationObserver(function () { if (celebrate()) mo.disconnect(); });
    var target = document.querySelector('cart-drawer') || document.body;
    mo.observe(target, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 5000);
  }

  function celebrate() {
    var v; try { v = sessionStorage.getItem('twg_new'); } catch (e) {}
    if (!v) return true;
    // wait until the re-rendered drawer actually holds the newly unlocked tier
    var els = v.split(',').map(function (t) { return document.querySelector('[data-twg-tier="' + t + '"]'); }).filter(Boolean);
    if (!els.length) return false;
    ssPop('twg_new');
    var first = els[0];
    els.forEach(function (el) { el.classList.add('twg__new'); setTimeout(function () { el.classList.remove('twg__new'); }, 3200); });
    // make sure they SEE the gift land, even if they were scrolled down the bag
    if (first && first.scrollIntoView) setTimeout(function () { first.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); }, 60);
    return true;
  }

  function sync(cart) {
    var c = cfg();
    if (!c) return Promise.resolve();
    if (busy) { pending = true; return Promise.resolve(); }
    // loop guard: max 6 engine writes per 10s
    if (++runs > 6) return Promise.resolve();
    clearTimeout(runsReset); runsReset = setTimeout(function () { runs = 0; }, 10000);
    busy = true;
    return (cart ? Promise.resolve(cart) : getCart()).then(function (cart) {
      lastCart = cart;
      var p = plan(c, cart);
      if (!p.updates && !p.adds.length) { runs = Math.max(0, runs - 1); return false; }
      var hadTiers = {};
      cart.items.forEach(function (i) { if (isGift(i)) hadTiers[prop(i, '_tw_gift')] = 1; });
      setBusy(true);
      var step = p.updates ? post('cart/update.js', { updates: p.updates }) : Promise.resolve();
      return step.then(function () {
        if (!p.adds.length) return;
        var items = p.adds.map(function (a) { return { id: a.id, quantity: 1, properties: { _tw_gift: a.tier } }; });
        return post('cart/add.js', { items: items }).then(function (res) {
          if (res.ok) return;
          // one item failed (sold out / unpublished): add one by one, remember failures
          return items.reduce(function (chain, it) {
            return chain.then(function () {
              return post('cart/add.js', { items: [it] }).then(function (r) { if (!r.ok) bad[it.id] = 1; });
            });
          }, Promise.resolve());
        });
      }).then(function () {
        var fresh = p.adds.map(function (a) { return a.tier; }).filter(function (t, i, arr) { return !hadTiers[t] && arr.indexOf(t) === i; });
        return fresh; // [] still means "cart changed, refresh"

      });
    }).then(function (fresh) {
      busy = false;
      if (fresh) { refreshUI(fresh); getCart().then(function (c2) { lastCart = c2; }); } else setBusy(false);
      if (pending) { pending = false; return sync(); }
    }, function () { busy = false; pending = false; setBusy(false); });
  }

  // Taps inside the drawer strip
  document.addEventListener('click', function (e) {
    var dot = e.target.closest && e.target.closest('[data-twg-beanie]');
    var tile = e.target.closest && e.target.closest('[data-twg-acc]');
    if (!dot && !tile) return;
    e.preventDefault();
    if (dot) {
      if (dot.classList.contains('is-on')) return;
      lsSet(KEY_BEANIE, Number(dot.getAttribute('data-twg-beanie')));
      var dots = dot.parentNode.querySelectorAll('[data-twg-beanie]');
      for (var i = 0; i < dots.length; i++) dots[i].classList.toggle('is-on', dots[i] === dot);
    } else {
      if (tile.classList.contains('is-on')) return; // always keep N picked: tapping a new one swaps out the oldest pick
      var id = Number(tile.getAttribute('data-twg-acc'));
      var c = cfg(); var n = (c && c.n) || 2;
      var on = [].slice.call(tile.parentNode.querySelectorAll('[data-twg-acc].is-on')).map(function (t) { return Number(t.getAttribute('data-twg-acc')); });
      var saved = (lsGet(KEY_PICKS) || []).filter(function (x) { return on.indexOf(x) > -1; });
      on.forEach(function (x) { if (saved.indexOf(x) === -1) saved.push(x); }); // oldest first
      saved.push(id);
      while (saved.length > n) saved.shift();
      lsSet(KEY_PICKS, saved);
      var tiles = tile.parentNode.querySelectorAll('[data-twg-acc]');
      for (var k = 0; k < tiles.length; k++) tiles[k].classList.toggle('is-on', saved.indexOf(Number(tiles[k].getAttribute('data-twg-acc'))) > -1);
    }
    runs = 0;
    sync();
  });

  // Gap closer: one-tap add of the item that unlocks the next tier
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-twg-add]');
    if (!b) return;
    e.preventDefault();
    b.disabled = true;
    post('cart/add.js', { items: [{ id: Number(b.getAttribute('data-twg-add')), quantity: 1 }] }).then(function () {
      runs = 0;
      return sync();
    }).then(function () { refreshDrawer(); });
  });

  // Losing-gift warning: removing / lowering an item that would drop them under a tier
  function money(cents, c) {
    try { return new Intl.NumberFormat(c.loc || undefined, { style: 'currency', currency: c.cur || 'USD', maximumFractionDigits: (cents % 100 === 0) ? 0 : 2 }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2); }
  }
  function el(tag, cls, text) { var n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; }
  function closeLose() { var s = document.querySelector('.twg-lose'); if (s) s.parentNode.removeChild(s); }
  function showLose(link, href, lost, c) {
    closeLose();
    var S = c.s || {}, total = 0;
    var wrap = el('div', 'twg-lose'); wrap.setAttribute('role', 'dialog'); wrap.setAttribute('aria-modal', 'true');
    var bg = el('button', 'twg-lose__bg'); bg.type = 'button'; bg.setAttribute('aria-label', S.keep ? S.keep.replace('__AMT__', '') : 'Close');
    var sheet = el('div', 'twg-lose__sheet');
    var pill = el('span', 'twg__pill', S.title || "Wait! You'll lose your free gifts");
    sheet.appendChild(pill);
    sheet.appendChild(el('p', 'twg-lose__txt', S.body || 'Removing this item will also remove:'));
    lost.forEach(function (i) {
      total += i.original_line_price;
      var row = el('div', 'twg-lose__row');
      var img = el('img'); img.alt = ''; img.src = i.image ? (i.image + (i.image.indexOf('?') > -1 ? '&' : '?') + 'width=100') : ''; row.appendChild(img);
      row.appendChild(el('span', 'twg-lose__name', i.product_title));
      var pr = el('span', 'twg__prices'); pr.appendChild(el('s', '', money(i.original_line_price, c))); pr.appendChild(el('span', 'twg__badge', S.free || 'FREE'));
      row.appendChild(pr);
      sheet.appendChild(row);
    });
    var keep = el('button', 'twg-lose__keep', (S.keep || 'Keep my __AMT__ in free gifts').replace('__AMT__', money(total, c))); keep.type = 'button';
    var rm = el('button', 'twg-lose__rm', S.remove || 'Remove anyway'); rm.type = 'button';
    sheet.appendChild(keep); sheet.appendChild(rm);
    wrap.appendChild(bg); wrap.appendChild(sheet);
    document.body.appendChild(wrap);
    // the theme's drawer closes on any click outside itself; let clicks inside this sheet through
    var dr = document.querySelector('cart-drawer');
    if (dr && !dr.__twgOk && typeof dr.hideForOutsideClickTarget === 'function') {
      dr.__twgOk = 1;
      var h = dr.hideForOutsideClickTarget, al = dr.allowOutsideClickForTarget;
      var inSheet = function (t) { return !!(t && t.closest && t.closest('.twg-lose')); };
      dr.hideForOutsideClickTarget = function (t) { return !inSheet(t) && h.call(this, t); };
      if (typeof al === 'function') dr.allowOutsideClickForTarget = function (t) { return inSheet(t) || al.call(this, t); };
    }
    bg.addEventListener('click', closeLose);
    keep.addEventListener('click', closeLose);
    rm.addEventListener('click', function () {
      closeLose();
      if (link.isConnected) { bypass = href; link.click(); return; }
      var u = new URL(href, location.origin);
      post('cart/change.js', { id: u.searchParams.get('id'), quantity: Number(u.searchParams.get('quantity')) }).then(function () {
        runs = 0; return sync();
      }).then(function () { refreshDrawer(); });
    });
    keep.focus();
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="/cart/change"]');
    if (!a || !a.closest('cart-drawer, #main')) return;
    var href = a.getAttribute('href');
    if (bypass === href) { bypass = null; return; }
    var c = cfg();
    if (!c || !lastCart) return;
    var u = new URL(href, location.origin), key = u.searchParams.get('id'), q = parseInt(u.searchParams.get('quantity'), 10);
    var line = lastCart.items.filter(function (i) { return i.key === key; })[0];
    if (!line || isGift(line) || isNaN(q) || q >= line.quantity) return;
    var base = plan(c, lastCart).base - (line.final_line_price / line.quantity) * (line.quantity - q);
    var idx = { t1: 0, t2: 1, t3: 2 };
    var lost = lastCart.items.filter(function (i) { var t = prop(i, '_tw_gift'); return t && base < c.t[idx[t]]; });
    if (!lost.length) return;
    e.preventDefault(); e.stopImmediatePropagation();
    showLose(a, href, lost, c);
  }, true);

  // Other code that adds to the bag and only asks the drawer to refresh (fit builder, bundles, apps)
  document.addEventListener('cart:refresh', function () {
    if (selfRefresh) return;
    clearTimeout(refT);
    refT = setTimeout(function () { sync(); }, 200);
  });

  // Any cart change made by the theme (add to bag, qty change, remove)
  document.addEventListener('cart:change', function (e) {
    var cart = e.detail && e.detail.cart;
    // only trust a full cart object (cart/add.js responses carry the added lines only)
    if (!(cart && cart.items && typeof cart.items_subtotal_price === 'number')) cart = null;
    if (cart) lastCart = cart;
    setTimeout(function () { sync(cart); }, 30);
  });

  function boot() { if (!celebrate()) ssPop('twg_new'); sync(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.addEventListener('pageshow', function (e) { if (e.persisted) sync(); });

  window.__twGifts = { plan: plan, sync: sync };
})();
